import type { RefObject } from 'react';
import type { HostInstance } from 'react-native';

import { noop } from './noop';

export const measureLayoutPosition = async (
  parentRef?: RefObject<HostInstance | null> | null,
  childRef?: RefObject<HostInstance | null> | null,
): Promise<Readonly<{ x: number; y: number }>> => {
  const parent = parentRef?.current;
  const child = childRef?.current;

  if (!parent || !child) throw new Error('Missing parent or child reference.');

  return new Promise((resolve) => {
    child.measureLayout(
      parent,
      (x, y) => {
        resolve({ x, y });
      },
      noop,
    );
  });
};
